export class SkillInfo {
  constructor(json) {
    this.isOutbound = json.isOutbound;
    this.mediaType = json.mediaType;
    this.skillId = json.skillId;
    this.skillName = json.skillName;
  }
}
